import { render, staticRenderFns } from "./MessageRecordDetailPage.vue?vue&type=template&id=37a69b3b&scoped=true"
import script from "./MessageRecordDetailPage.vue?vue&type=script&lang=js"
export * from "./MessageRecordDetailPage.vue?vue&type=script&lang=js"
import style0 from "./MessageRecordDetailPage.vue?vue&type=style&index=0&id=37a69b3b&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a69b3b",
  null
  
)

export default component.exports